import { useQuery } from "@tanstack/react-query";
import { UseGetQuestionsBySurveyIdProps } from '.';
import { queryKeys } from "@/lib/useQuery/queryKeys";


export function useGetQuestionsBySurveyId({
    surveyId,
    isArchived = false,
    sortByCreatedAtAscending = true,
    showAll = false
}: UseGetQuestionsBySurveyIdProps) {
    return useQuery({
        ...queryKeys.question.list._ctx.bySurveyId({
            surveyId: surveyId!,
            isArchived,
            sortByCreatedAtAscending,
            showAll
        }),
        enabled: !!surveyId,
        staleTime: 1000 * 60 * 1, // 1 minute
    });
}
